module.exports = __webpack_public_path__ + "static/media/s1.83850f69.jpg";